module.exports = __webpack_public_path__ + "img/main_bg.1ad7cf07.jpg";